export default "__VITE_ASSET__BPMXmu$B__"